var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SatisfactionComp',{attrs:{"type":_vm.type,"qrcode":_vm.qrcode}})
}
var staticRenderFns = []

export { render, staticRenderFns }